module.exports = __webpack_public_path__ + "img/himanshu dev.6dd0c3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/himanshu dev.png
// module id = 628
// module chunks = 1